import getBeautyList from "./getBeautyList";
import createBeauty from "./createBeauty";
import getBeauty from "./getBeauty";
import changeStatus from "./changeStatus";
import updateBeauty from "./updateBeauty";
import deleteBeauty from "./deleteBeauty";

export default {
  getBeautyList,
  createBeauty,
  getBeauty,
  changeStatus,
  updateBeauty,
  deleteBeauty,
};
